export const DOCUMENT_STATUS = {
  DRAFT: 'DRAFT',
  IN_APPROVAL: 'IN_APPROVAL',
  RETURNED: 'RETURNED',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  COMPLETED: 'COMPLETED',
  VOIDED: 'VOIDED',
  CORRECTED: 'CORRECTED',
} as const;

export type DocumentStatus = (typeof DOCUMENT_STATUS)[keyof typeof DOCUMENT_STATUS];

export const DOCUMENT_TYPE = {
  EXPENSE_REIMBURSEMENT: 'EXPENSE_REIMBURSEMENT',
  LOAN: 'LOAN',
  CASH_REPAYMENT: 'CASH_REPAYMENT',
  LOAN_OFFSET: 'LOAN_OFFSET',
  CORPORATE_PAYMENT: 'CORPORATE_PAYMENT',
} as const;

export type DocumentType = (typeof DOCUMENT_TYPE)[keyof typeof DOCUMENT_TYPE];

export const DOCUMENT_ACTION = {
  SUBMIT: 'SUBMIT',
  WITHDRAW: 'WITHDRAW',
  RETURN: 'RETURN',
  REJECT: 'REJECT',
  APPROVE: 'APPROVE',
  COMPLETE: 'COMPLETE',
  VOID: 'VOID',
  CORRECT: 'CORRECT',
} as const;
export type DocumentAction = (typeof DOCUMENT_ACTION)[keyof typeof DOCUMENT_ACTION];

const TRANSITIONS: Record<DocumentStatus, Partial<Record<DocumentAction, DocumentStatus>>> = {
  DRAFT: { SUBMIT: 'IN_APPROVAL', VOID: 'VOIDED' },
  IN_APPROVAL: { WITHDRAW: 'DRAFT', RETURN: 'RETURNED', REJECT: 'REJECTED', APPROVE: 'APPROVED' },
  RETURNED: { SUBMIT: 'IN_APPROVAL', VOID: 'VOIDED' },
  REJECTED: {},
  APPROVED: { COMPLETE: 'COMPLETED', VOID: 'VOIDED' },
  COMPLETED: { CORRECT: 'CORRECTED' },
  VOIDED: {},
  CORRECTED: {},
};

export function nextDocumentStatus(
  current: DocumentStatus,
  action: DocumentAction,
): DocumentStatus | null {
  return TRANSITIONS[current][action] ?? null;
}

export function isDocumentEditable(status: DocumentStatus): boolean {
  return status === DOCUMENT_STATUS.DRAFT || status === DOCUMENT_STATUS.RETURNED;
}
